import { Link } from 'react-router-dom';

const WHY_IMAGE =
  'https://roadtechservices.netlify.app/images/generator-repair-1-850w.jpeg';

const reasons = [
  {
    icon: 'ri-home-gear-line',
    title: 'We Come to You',
    description:
      'Zero hauling required. Our technician arrives at your property fully equipped and ready to get the job done.',
  },
  {
    icon: 'ri-time-line',
    title: 'Same-Day Service Available',
    description:
      'Most repairs are completed the same day when the issue is described correctly and parts are on hand.',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Multi-Brand Certified',
    description:
      'Master Certified in Briggs & Stratton, Silver-Level in Stihl, and certified in Kohler and Kawasaki.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Transparent Pricing',
    description:
      'No surprises. You receive a clear estimate before any work begins — honest service every time.',
  },
];

export default function WhyChooseSection() {
  return (
    <section className="bg-neutral-900 py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <p className="text-orange-500 text-xs font-bold uppercase tracking-widest mb-4">
              Why Choose Us
            </p>
            <h2 className="font-display text-4xl lg:text-5xl font-bold uppercase tracking-tight text-white mb-6 leading-tight">
              Expert Repair Without the Hassle
            </h2>
            <p className="text-neutral-400 text-base leading-relaxed mb-10">
              We bring certified repair directly to your doorstep — saving you
              the time and frustration of transporting heavy equipment. With
              same-day service available and transparent pricing, Road Tech
              Services is the stress-free choice.
            </p>

            <div className="space-y-6">
              {reasons.map((reason) => (
                <div key={reason.title} className="flex items-start gap-5">
                  <div className="w-11 h-11 flex items-center justify-center bg-orange-600/15 border border-orange-600/20 rounded-xl flex-shrink-0 mt-0.5">
                    <i className={`${reason.icon} text-orange-500 text-lg`} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-sm mb-1">
                      {reason.title}
                    </h3>
                    <p className="text-neutral-400 text-sm leading-relaxed">
                      {reason.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Link
                to="/services"
                className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-semibold px-7 py-3.5 rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                Learn More About Our Services
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>

          {/* Image */}
          <div className="relative h-[500px] lg:h-[580px] rounded-2xl overflow-hidden">
            <img
              src={WHY_IMAGE}
              alt="Road Tech Services expert generator repair on-site"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-orange-600/10 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
